import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { AppComponent } from "./app.component";

// Providers
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "@environments/environment";

import { APP_BASE_HREF, CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ComponentsModule, CoreModule } from "world-archery-lib";
import { AppRoutingModule } from "./app.routing.module";
import { HttpClientModule } from '@angular/common/http';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    CommonModule,
    CommonPageComponentsModule,
    FormsModule,
    ComponentsModule,
    CoreModule,
    ServiceWorkerModule.register("/sites/all/modules/custom/wa_angular/includes/plugins/content_types/main/ngsw-worker.js", {
      enabled: environment.production,
    })
  ],
  providers: [{ provide: APP_BASE_HREF, useValue: "/" }],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    if (environment.production === true) {
      console.log = (data) => { }
    }
  }
}
